import React, { useReducer, createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import { reducer, actions } from '../store';
import { PLATFORMS } from '../constants';

const FooterContext = createContext();

export const getFooterContext = () => useContext(FooterContext);

export const getProps = (state, dispatch) => {
  return {
    ...state,
    onSubmitEmail: (email, baseUrl, releaseBodyOverflow) =>
      actions.submitEmail(email, baseUrl, releaseBodyOverflow)(dispatch),
    onHideModal: () => actions.hideModal()(dispatch),
    onChangeEmailAddress: emailAddress => {
      actions.onChangeEmailAddress(emailAddress)(dispatch);
    },
  };
};

export const FooterProvider = ({ initialState, children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <FooterContext.Provider value={{ ...getProps(state, dispatch) }}>
      {children}
    </FooterContext.Provider>
  );
};

FooterProvider.propTypes = {
  children: PropTypes.node.isRequired,
  initialState: PropTypes.exact({
    isB2B: PropTypes.bool,
    isAuthenticated: PropTypes.bool,
    isModalVisible: PropTypes.bool,
    emailAddress: PropTypes.string,
    baseUrl: PropTypes.string,
    platform: PropTypes.oneOf(Object.values(PLATFORMS)),
    error: PropTypes.string,
  }).isRequired,
};

export default FooterContext;
